import { render, staticRenderFns } from "./MainColumnsDialog.vue?vue&type=template&id=7a609fbc&scoped=true&"
import script from "./MainColumnsDialog.vue?vue&type=script&lang=js&"
export * from "./MainColumnsDialog.vue?vue&type=script&lang=js&"
import style0 from "./MainColumnsDialog.vue?vue&type=style&index=0&id=7a609fbc&prod&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "7a609fbc",
  null
  
)

export default component.exports